import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mobile-title" }
const _hoisted_2 = { class: "dates" }
const _hoisted_3 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PulseInput = _resolveComponent("PulseInput")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Popover = _resolveComponent("Popover")

  return (_openBlock(), _createBlock(_component_Popover, {
    modelValue: $data.show,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.show) = $event)),
    class: "pulse-calendar",
    "popper-class": "feed-calendar-popover",
    placement: "bottom-start",
    "show-arrow": false,
    offset: -1,
    mask: _ctx.$responsive.mobile
  }, {
    reference: _withCtx(() => [
      _createVNode(_component_PulseInput, {
        modelValue: $options.c_value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($options.c_value) = $event)),
        class: "pulse-input",
        icon: "calendar",
        underline: "",
        readonly: "",
        onClick: _cache[1] || (_cache[1] = $event => ($data.show = !$data.show))
      }, null, 8 /* PROPS */, ["modelValue"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[4] || (_cache[4] = _createElementVNode("span", null, "Date", -1 /* HOISTED */)),
        _createVNode(_component_Icon, {
          class: "pointer",
          icon: "x-close",
          size: "1.8rem",
          stroke: "var(--gray-500)",
          "stroke-width": "1",
          onClick: _cache[2] || (_cache[2] = $event => ($data.show = false))
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.c_dates, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.value,
            class: _normalizeClass([{active: item.value === _ctx.value}, "date"]),
            onClick: $event => ($options.onChange(item.value))
          }, _toDisplayString(item.title), 11 /* TEXT, CLASS, PROPS */, _hoisted_3))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "mask"]))
}